module.exports = __webpack_public_path__ + "86bf4ea6c1.png";